/* eslint-disable no-param-reassign */
import React, { useMemo } from 'react';

import styles from './SourceIcon.module.scss';
import { sourceIsMyTests } from './utils';

import TciIcon from '../../../../public/assets/images/source/tci-icon.svg';
import DistrictIcon from '../../../../public/assets/images/source/district-icon.svg';
import OtherTeachersIcon from '../../../../public/assets/images/source/other-teachers-icon.svg';

const SOURCE_URLS = {
  'MY DISTRICT': DistrictIcon,
  'OTHER TEACHERS\' TESTS': OtherTeachersIcon,
  TCI: TciIcon,
};

const SOURCE_ALT_TAGS = {
  'MY DISTRICT': 'My District',
  'OTHER TEACHERS\' TESTS': 'Other Teachers',
  TCI: 'TCI',
};

interface Props {
  source?: string;
  firstName?: string;
  lastName?: string;
  size?: number;
}

const SourceIcon = ({ source = '', size = 24, firstName, lastName }: Props) => {
  source = source || '';
  const upperSource = source.toUpperCase();

  if (!Object.keys(SOURCE_URLS).includes(upperSource) && !sourceIsMyTests(upperSource)) {
    return null;
  }

  const url = useMemo(
    () => SOURCE_URLS[upperSource as keyof typeof SOURCE_URLS],
    [source],
  );

  const initialName = firstName && lastName ? firstName.charAt(0) + lastName.charAt(0) : '';

  if (url) {
    return (
      <img alt={SOURCE_ALT_TAGS[upperSource as keyof typeof SOURCE_URLS]} src={url} width={size} />
    );
  }

  if (!initialName) return null;

  return (
    <div
      className={styles.initialName}
      style={{ fontSize: size / 2, height: size, width: size }}
    >
      {initialName}
    </div>
  );
};

export default SourceIcon;
